module.exports = __webpack_public_path__ + "static/img/微盟.6236c0e3.png";